import { normalizeInternalRole, type InternalRole } from "@/lib/roles";
import { ProductScreenshot } from "./ProductScreenshot";
import { UPDATE_SCREENS } from "./update-screens";

const STORIES = {
	"crm-next-action": {
		roles: ["admin", "sales"],
		location: "Cherry → Sales → CRM → Opportunities → Add activity",
		alt: "Cherry Add activity form with a Next follow-up date, conversation notes, and Log button",
		caption: "Example conversation and follow-up date shown. Log records the activity; it does not send a customer message.",
	},
	"client-purchase-reports": {
		roles: ["admin", "sales"],
		location: "Cherry → Sales → Analytics → Client Report",
		alt: "Cherry Client Purchase Report with example purchase lines and Download CSV",
		caption: "Example client and purchase figures shown.",
	},
	"logistics-review-alerts": {
		roles: ["admin", "logistics", "warehouse"],
		location: "Cherry → Logistics → Inbound Deliveries",
		alt: "Cherry logistics sidebar with an Inbound Deliveries Review label and Mark reviewed control",
		caption: "Example update shown before it is marked reviewed.",
	},
} satisfies Record<keyof typeof UPDATE_SCREENS, {
	roles: InternalRole[];
	location: string;
	alt: string;
	caption: string;
}>;

export function UpdateScreenshot({ entryId, userRole }: { entryId: string; userRole: string | undefined }) {
	if (!Object.hasOwn(STORIES, entryId)) return null;
	const id = entryId as keyof typeof STORIES;
	const story = STORIES[id];
	const role = normalizeInternalRole(userRole);
	if (!role || !(story.roles as readonly InternalRole[]).includes(role)) return null;
	return (
		<div className="mt-5 overflow-hidden rounded-xl border border-border bg-background">
			<ProductScreenshot screen={UPDATE_SCREENS[id]} alt={story.alt} location={story.location} caption={story.caption} />
		</div>
	);
}
